import {Grid, Typography} from "@mui/material";
import PropTypes from "prop-types";

const Container = ({ title, spacing, children }) => {
  return (
    <Grid
      container
      className="cardContainer"
      justifyContent="center"
      spacing={1}
      sx={{ mt: 0.5, mb: 4 }}
    >
      <Grid item xs={12} align="center">
        <Typography variant="h3">{title}</Typography>
      </Grid>

      <Grid
        container
        className="contentContainer"
        justifyContent="center"
        spacing={spacing ? 5 : undefined}
        sx={{ mb: 4 }}
      >
        {children}
      </Grid>
    </Grid>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  spacing: PropTypes.bool,
};

export default Container;
